// extracted by mini-css-extract-plugin
export default {"Register":"Register_Register__VEM4O","details":"Register_details__WzbmD","section":"Register_section__y+kIa","Button":"Register_Button__kNYlD","Bottom":"Register_Bottom__N3yLE"};